import {
  Module,
  VuexModule,
  getModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';
import store, { Site } from '@/store';
// import {auth} from "@/network/auth/auth";
// import axios from "axios";
import sha1 from 'sha1';
import md5 from 'md5';
// import {decode} from 'js-base64';
import {
  withoutAuthAxios,
  axios,
  notifierAPI,
  SSOAPI,
} from '@/network/network';
import allProducts from './allProducts';
import { AccountData, User, ProductType, GroupUser } from './index.d';
import notif_service from '@/modules/notifications';
import { timestampPrepareDate } from '@/modules/tools'

const fingerPrintDefault = '111finger111';

const userInfo = localStorage.getItem('AppUserinfo');
const urlParams = new URLSearchParams(window.location.search);

const tokenFromParams = urlParams.get('token');

if (tokenFromParams) {
  localStorage.setItem('AppToken', tokenFromParams);
  localStorage.setItem('fingerPrint', fingerPrintDefault);
}

const getAdvInfoSetting = (s) => s.Name === 'adviserinfo' && s.Product === 'Rixtrema';

interface LoginRequest {
  login?: string;
  fingerPrint?: string;
  password?: string;
  Token?: string;
  disableFinger?: boolean;
}

interface GroupTokenRequest {
  Token?: string;
  error?: string;
  userId?: number;
}

@Module({
  namespaced: true,
  name: 'user',
  store,
  dynamic: true,
})
class UserData extends VuexModule {
  salt: string = '2BxGf1tmIKs';
  userInfo: User = userInfo
    ? JSON.parse(userInfo)
    : {
        UserName: '',
        Email: '',
        UserID: '',
        Login: '',
      };

  token: string | null = tokenFromParams || localStorage.getItem('AppToken');
  newToken: string | null = localStorage.getItem('AppNewToken');
  password: string | null = localStorage.getItem('AppPassword');
  login: string = localStorage.getItem('AppLogin') || '';
  id: string | null = localStorage.getItem('AppUserID') || this.userInfo.UserID;
  noti: boolean = false;
  fingerPrintDefault: string = fingerPrintDefault;
  fingerPrint: string =
    localStorage.getItem('fingerPrint') || this.fingerPrintDefault;
  iframe: boolean = false;
  request: boolean = false;

  hasGroupUsers: boolean = false;
  groupUsers: GroupUser[];
  groupTokenStorage: object = {};
  activeGroupToken: string = '';

  base: string = 'https://localhost';
  firstIframe: boolean = false;
  rawPassword: string | null = localStorage.getItem('AppRawPassword');

  isMobile: boolean = false;
  sortedProducts: string[] = JSON.parse(
    localStorage.getItem('appDrawerSort') || '[]',
  );

  lastAccountData: AccountData | null = null;
  expired: boolean = false;

  settings: any[] = null

  currentSites: any[] = allProducts;


  get settingAdvInfo(){
    return this.settings.find(getAdvInfoSetting);
  }

  @Mutation
  setAdvInfo(Info: string){
    const infoIdx = this.settings.findIndex(getAdvInfoSetting);

    if (infoIdx > -1){

      this.settings.splice(infoIdx, 1, Info)

    } else {

      this.settings.push(Info);

    }

  }
  @Action({ rawError: true, commit: 'setAdvInfo' })
  async saveAdvInfo(info){

    info = JSON.stringify(info)

    const settingAdvInfo =  this.settingAdvInfo;

    if (settingAdvInfo && settingAdvInfo.Id){

      settingAdvInfo.Info = info;

      await axios.post('settings/update/' + settingAdvInfo.Id, JSON.stringify(settingAdvInfo));

      return settingAdvInfo


    } else {

      var data: any = {}
      data.product = 'Rixtrema';
      data.IsPublic = true
      data.Type = 'USER';
      data.Name = 'adviserinfo';
      data.Info = info;

      await axios.post('settings/create', JSON.stringify(data));

      return data;

    }


  }

  get licenses() {

    const exceptions = ['lsyork@proactiveadvisors.com', 'robert.lemieux@inter-pret.ca'];
    const licenses = [];
    
    (this.userInfo?.Licenses || []).forEach(l => {
      
      if (l.ProductCode !== 'LEXE' || exceptions.indexOf(this.login.toLowerCase()) === -1){

        licenses.push(l);

        if (l.ProductCode === 'PCT' && (l.Permissions || []).find(p => p.Code === "ACCESS_OLD_VERSION")){

          licenses.push({
            ...l,
            ProductCode: 'OLD_PCT'
          });
       
        }
        
      }



    })
    
    return licenses;
  }

  get oldPct(){
    const pct =  this.licenses.find(l => l.ProductCode === 'PCT')

    if (pct){
      return pct.Permissions.find(p => p.Code === 'ACCESS_OLD_VERSION');
    }

    return;
  }

  get userProducts() {
    let currentSites = [...this.currentSites];

    let sortedProducts: any[] = [];

    this.sortedProducts.forEach((product: any) => {
      const currentProductIdx = currentSites.findIndex(
        (site) => site.id === product,
      );

      if (currentProductIdx > -1) {
        sortedProducts.push(currentSites[currentProductIdx]);
        currentSites.splice(currentProductIdx, 1);
      }
    });

    sortedProducts = [...sortedProducts, ...currentSites];


    return sortedProducts.map((product: ProductType) => {
      const bought: boolean = Boolean(
        this.licenses.find(
          (license: any) =>
            license.ProductCode === product.productCode ||
            product.productCode === 'PDF',
        ),
      );

      return { ...product, bought };
    });
  }

  @Action({ rawError: true })
  async sendMetric(data: any) {
    console.log('metricID', data);
    try {
      let request = {
        Payload: JSON.stringify(data.payload),
        Message: data.metricID,
        UserAgent: window.navigator.userAgent,
        Product: 'CRM',
        Version: '1.0.0',
      };
      await axios.post(
        `https://rixtrema.net/api/userdata/analytics/event`,
        request,
      );
    } catch (err) {
      console.log(data.payload, data.metricID, err);
    }
  }

  @Action
  async register(accountData?: AccountData) {
    try {
      if (accountData) {
        this.setLastAccountData(accountData);
      }

      const response: any = await withoutAuthAxios.post(
        '/user/Register',
        this.lastAccountData,
      );

      console.log('resonse register', response, response.status);

      return { result: response || 'Success' };
    } catch (error) {
      if (error?.request?.status === 400) {
        let errorText = 'You missed required fields';

        return { error: errorText };
      }

      return error?.response;
    }
  }

  @Mutation
  changeDefaultLink(data: { id: string; link: string }) {
    const { id, link } = data;
    const idx = this.currentSites.findIndex((s) => s.id === id);

    if (idx > -1) {
      this.currentSites[idx].defaultLink = link;
    }
  }

  @Mutation
  setLastAccountData(accountData: AccountData | null) {
    this.lastAccountData = accountData;
  }

  @Mutation
  setSortedProducts(products: any[]) {
    this.sortedProducts = products;
    localStorage.setItem('appDrawerSort', JSON.stringify(products));
  }

  @Mutation
  changeMobile(boo: boolean) {
    this.isMobile = boo;
  }

  @Mutation
  setCurrentSites(sites: any) {
    this.currentSites = sites;
  }

  @Mutation
  changeSiteField(site: Site) {

    const siteIdx = this.currentSites.findIndex(
      (old: Site) => old.id === site.id,
    );

    const newSite = this.currentSites[siteIdx];

    console.log('siteidx', siteIdx, newSite)

    if (newSite) {
      if (site.link) {
        newSite.link = site.link;
      }

      if (site.defaultLink) {
        newSite.defaultLink = site.defaultLink;
      }
    }

    this.currentSites.splice(siteIdx, 1, newSite);
  }

  @Mutation
  setFirstIframe(boo: boolean) {
    this.firstIframe = boo;
  }

  @Mutation
  setBase(base: string) {
    this.base = base;
  }

  @Mutation
  setIframe(boo: boolean) {
    this.iframe = boo;
  }

  @Mutation
  setRequest(boo: boolean) {
    this.request = boo;
  }

  @Mutation
  setUser(userData: User) {
    console.log('userData', userData);

    // localStorage['CRM_UserInfo'] = JSON.stringify(userData)
    if (this.token && userData && !userData.error) {
      this.userInfo = userData;

      localStorage.setItem('AppUserinfo', JSON.stringify(this.userInfo));
      localStorage.setItem('AppToken', this.token);
      localStorage.setItem('AppLogin', this.userInfo.Login || '');
      localStorage.setItem('AppUserID', this.userInfo.UserID || '');

      axios.defaults.headers.common['Token'] = this.token;
      axios.defaults.headers.common['Login'] = this.login;
      axios.defaults.headers.common['fingerPrint'] = this.fingerPrint;

      notifierAPI.defaults.headers.common['Token'] = this.token;
      notifierAPI.defaults.headers.common['Login'] = this.login;
      notifierAPI.defaults.headers.common['fingerPrint'] = this.fingerPrint;

      SSOAPI.defaults.headers.common['Token'] = this.token;
      SSOAPI.defaults.headers.common['Login'] = this.login;
      SSOAPI.defaults.headers.common['fingerPrint'] = this.fingerPrint;

      notif_service.initSocket({
        token: this.token,
        fingerPrint: this.fingerPrint,
      });

      notif_service.socket.onmessage = function(notification: any) {
        console.log('onmesssage!!!', notification);

        if (notification.data) {
          notif_service.setFastMessage(notification.data);
        }
      };
    }
  }

  @Mutation
  removeUser() {
    console.log('removeUser');

    this.userInfo = {
      UserName: '',
      Email: '',
      Login: '',
      UserID: '',
    };

    this.token = '';
    this.login = '';

    this.expired = false;

    localStorage.removeItem('AppToken');
    localStorage.removeItem('AppLogin');
    localStorage.removeItem('AppUserID');
    localStorage.removeItem('AppUserinfo');
    localStorage.removeItem('AppPassword');
    localStorage.removeItem('lastPSDate');

    axios.defaults.headers.common['Token'] = '';
    axios.defaults.headers.common['Login'] = '';
  }

  @Mutation
  setExpired(date: string) {

    this.expired = date && (new Date(timestampPrepareDate(date)) < new Date());

  }

  @Mutation
  setSettings(settings: any) {
    this.settings = settings || []
  }

  @Action({ commit: 'setUser', rawError: true })
  async getLogin(userData: LoginRequest) {
    const headers: LoginRequest = {};

    if (userData.login) {
      headers.login = userData.login;
    }

    if (!userData.disableFinger) {
      headers.fingerPrint = this.fingerPrint;
    }

    if (userData.password) {
      const sha1password = sha1(userData.password + this.salt);
      headers.password = sha1password;
    } else if (userData.Token) {
      headers.Token = userData.Token;
    }


    try {
      this.setFingerPrint();

      const response: any = await withoutAuthAxios.get('user/SignIn', {
        headers,
      });

      const data = await Promise.resolve(response);

      const responseList: any = await withoutAuthAxios.get('settings/list', {
        headers,
      });

      const dataList = await Promise.resolve(responseList);

      this.setSettings(dataList);

      console.log('req', data);

      if (data?.Token) {
        const { Token, Login, Password, HasGroupUsers, ChPwdDate } = data;

        this.setToken(Token);
        this.setNewToken(Token);
        this.setPassword(Password);
        this.setLogin(Login);
        this.setGroupUsers(HasGroupUsers);
        this.setExpired(ChPwdDate)
        axios.defaults.headers.common['Token'] = Token;
        axios.defaults.headers.common['Login'] = Login;
        axios.defaults.headers.common['fingerPrint'] = this.fingerPrint;

        notifierAPI.defaults.headers.common['Token'] = Token;
        notifierAPI.defaults.headers.common['Login'] = Login;
        notifierAPI.defaults.headers.common['fingerPrint'] = this.fingerPrint;

        return data;
      } else {
        return false;
      }
    } catch (err) {
      if (!err.response) {
        return { error: 'Network Error' };
      }

      return false;
    }
  }

  @Mutation
  setLogin(login: string) {
    localStorage.setItem('AppLogin', login);
    this.login = login;
  }

  @Mutation
  setPassword(password: string) {
    this.rawPassword = password;

    const hashpassword = '000' + md5(password) + '000';

    localStorage.setItem('AppPassword', hashpassword);
    this.password = hashpassword;
  }

  @Mutation
  setToken(token: string) {
    this.token = token;
  }

  @Mutation
  setNewToken(token: string) {
    this.newToken = token;
  }

  @Mutation
  setFingerPrint() {
    localStorage.setItem('fingerPrint', this.fingerPrint);
  }

  @Mutation
  setGroupUsers(hasUsers: boolean) {
    this.hasGroupUsers = hasUsers;
  }

  @Action({ rawError: true })
  async changePassword(data: any) {
    const { newPassword, Pin } = data;

    console.log('newData2', data);

    // try {
    const response: any = await axios.post('user/ChangePassword', {
      newPassword,
      Pin,
    });

    console.log('response', response);
    // if (response.data.result !== 'success') return Promise.reject()

    if (response.status === 204 || response.status === 200) {
      this.setExpired('');
      return Promise.resolve('Success');
    } else if (response.data?.message) {
      return Promise.resolve(response.data?.message);
    }

    return Promise.reject('unhandled error');

    // } catch (err) {

    //   console.log('err', err, typeof err, err.message);

    //   return Promise.reject(err.message)

    // }
  }

  @Action({ rawError: true })
  async preChangePassword(oldPassword: string) {
    try {
      const response: any = await axios.post('user/PreChangePassword', {
        OldPassword: sha1(oldPassword + this.salt),
      });

      console.log('response', response);
      // if (response.data.result !== 'success') return Promise.reject()

      if (response.status === 200 || response.status === 204) {
        return Promise.resolve('Success');
      } else if (response.data?.errors === 'Invalid password') {
        return Promise.resolve(response.data?.errors);
      }

      return Promise.reject('unhandled error');
    } catch (err) {
      return Promise.reject(err);
    }
  }

  @Action({ commit: 'removeUser', rawError: true })
  logout() {
    return { UserName: '', Email: '', Token: '' };
  }

  @Action({ rawError: true })
  async updatePassword(oldPassword: string, newPassword: string) {
    try {
      const response: any = await axios.post('change', {
        oldPassword,
        newPassword,
      });

      if (response.data.result !== 'success') return;
      return Promise.resolve(response.data.data.records as User);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  @Action({ rawError: true })
  async forgotPassword(username: string) {
    try {
      const response: any = await axios.post('forgot', { username });

      if (response.data.result !== 'success') return;
      return Promise.resolve(response.data.data.records as User);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  @Action({ rawError: true })
  async SetNewPassword(data: any) {
    const { NewPassword, Code, Email } = data;

    console.log('newData', data);

    try {
      const response: any = await axios.post('user/SetNewPassword', {
        NewPassword,
        Code,
        Email,
      });

      console.log('response', response);
      // if (response.data.result !== 'success') return Promise.reject()

      if (response.status === 204) {
        return Promise.resolve('Success');
      } else if (response.data?.errors) {
        return Promise.resolve(response.data?.errors);
      }

      return Promise.reject('unhandled error');
    } catch (err) {
      const errObj = JSON.parse(err?.request?.response || '{}');

      console.log('errObj', errObj.Message);

      return Promise.reject(errObj.Message);
    }
  }

  @Action({ rawError: true })
  async RestorePassword(Email: string) {
    try {
      const response: any = await axios.post('user/RestorePassword', { Email });

      console.log('response', response);
      // if (response.data.result !== 'success') return Promise.reject()

      if (response?.status === 200) {
        return Promise.resolve('Success');
      } else if (response?.data?.errors === 'Invalid password') {
        return Promise.resolve(response.data?.errors);
      }

      return Promise.reject('unhandled error');
    } catch (err) {
      let errText = err;

      if (err?.response?.status === 404) {
        errText = `This user doen't exist`;
      }

      return Promise.reject(errText);
    }
  }

  @Mutation
  toggleNoti(boo: boolean) {
    this.noti = boo;
  }

  @Action({ rawError: true })
  async getTrial(productCode: string) {
    const result = await axios.post(
      '/user/TrialRequest?trialDto.product=' + productCode,
    );
    return result;
  }

  @Action({ rawError: true })
  handleError(result: string) {
    if (
      result === 'Access denied (no license)' ||
      result === 'Access denied (wrong credentionals)'
    ) {
      localStorage.removeItem('AppToken');
      localStorage.removeItem('AppLogin');
      location.assign('/login');
    }
  }

  @Action({ rawError: true })
  async getMyGroupUsers() {
    try {
      const response: any = await axios.post('user/MyGroupUsers', {
        Start: 0,
        Count: 10000,
        Filter: '',
      });

      if (response?.status !== 200)
        return Promise.reject({
          error: 'Invalid response',
        });

      return (response?.data.Users || []) as GroupUser[];
    } catch (err) {
      return err;
    }
  }

  @Action({ commit: 'getGroupUserToken', rawError: true })
  async getGroupUserTokenFromApi(id: number) {
    if (this.groupTokenStorage[id]) {
      return { Token: this.groupTokenStorage[id] };
    }

    try {
      const response: any = await axios.post('user/GetGroupUserToken', {
        userId: id,
      });
      console.log('RESP', response);

      return { ...response?.data, userId: id };
    } catch (err) {
      if (!err.response) {
        return { error: 'Network Error' };
      }

      return { error: 'Default Error' };
    }
  }

  @Mutation
  getGroupUserToken(data: GroupTokenRequest) {
    if (data.error || !data.Token) return;

    const token = data.Token;

    this.groupTokenStorage[data.userId] = token;
    this.activeGroupToken = token;
  }

  @Mutation
  removeActiveGroupUserToken() {
    this.activeGroupToken = '';
  }

  @Action({ rawError: true })
  async getGroupLogin(userData: LoginRequest) {
    const headers: LoginRequest = {};

    headers.login = userData.login;
    headers.Token = userData.Token;
    headers.fingerPrint = this.fingerPrint;

    try {
      const response: any = await withoutAuthAxios.get('user/SignIn', {
        headers,
      });

      const data = await Promise.resolve(response);

      if (data?.Token) {
        const { Token, Login, Password, ID, Email, FName, LName } = data;

        const hashPassword = '000' + md5(Password) + '000';

        const messageForPost = {
          token: Token,
          fingerPrint: this.fingerPrint,
          login: Login,
          password: hashPassword,
          rawPassword: Password,
          appstore: true,
          userInfo: {
            UserName: `${FName} ${LName}`,
            Email: Email,
            UserID: ID,
            Login: Login,
          },
        };

        return messageForPost;
      } else {
        return false;
      }
    } catch (err) {
      if (!err.response) {
        return { error: 'Network Error' };
      }

      return false;
    }
  }
}

export default getModule(UserData);
